import { CUSTOMER_COUNT } from '@/constants/strings';
import { FC } from 'react';
import { CheckList } from '../CheckList';
import Logo, { LogoProps } from '../Logo';
import { Text } from '../Text';
import ThemeWrapper from '../ThemeWrapper';

const logos = ['GoDaddy', 'Echo', 'Clickup', 'Branch', 'Baggu', 'UberFreight'];

const TrialSocialProofColumn: FC = () => {
  return (
    <ThemeWrapper theme="theme-dark-violet" className="h-full p-2xs">
      <div className="surface-l0 flex flex-col justify-center gap-y-xl py-margin-section-md px-2xl h-full rounded-10 overflow-hidden">
        <Text type="h3" className="text-primary">{CUSTOMER_COUNT} businesses trust Front to:</Text>
        <CheckList items={[
          { id: '1', text: 'Boost average CSAT to 87%' },
          { id: '2', text: 'Improve productivity up to 46%' },
          { id: '3', text: 'Reduce average response time by 25%' },
        ]} />
        <div className="flex flex-wrap justify-center gap-s">
          {logos.map((logo: LogoProps['type']) => (
            <div key={logo} className="m-auto">
              <Logo type={logo} className="w-full" />
            </div>
          ))}
        </div>
      </div>
    </ThemeWrapper>
  );
};

export default TrialSocialProofColumn;
